import { Helmet } from 'react-helmet-async';
import Hero from "@/components/landing/Hero";
import ClansSection from "@/components/landing/ClansSection";
import FeatureList from "@/components/landing/FeatureList";
import Requirements from "@/components/landing/Requirements";
import CTASection from "@/components/landing/CTASection";
import GenerateIcons from "@/components/GenerateIcons";

const Index = () => {
  const siteTitle = "The Flying Dutchman - World of Warships EU Community";
  const siteDescription = "Join The Flying Dutchman, a thriving World of Warships EU community founded in 2017. Three active clans offering competitive gameplay, casual fun, and a welcoming community.";

  return (
    <div className="min-h-screen">
      <GenerateIcons />
      <Helmet>
        <title>{siteTitle}</title>
        <meta name="description" content={siteDescription} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={siteTitle} />
        <meta property="og:description" content={siteDescription} />
        <meta property="og:image" content="/og-image.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={siteTitle} />
        <meta name="twitter:description" content={siteDescription} />
        <meta name="twitter:image" content="/og-image.png" />

        {/* Additional SEO tags */}
        <meta name="keywords" content="World of Warships, WoWS, clan, gaming community, EU server, competitive gaming, TFD clan, The Flying Dutchman" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://tfd-clan.com" />

        {/* JSON-LD structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "The Flying Dutchman",
            "description": siteDescription,
            "url": "https://tfd-clan.com",
            "logo": "/og-image.png",
            "sameAs": [
              "https://discord.gg/29gn3mXqtA"
            ]
          })}
        </script>
      </Helmet>

      <Hero />
      <ClansSection />
      <FeatureList />
      <Requirements />
      <CTASection />
    </div>
  );
};

export default Index;